// Hardcoded values, use lists from DB when BE is ready
import { AppConfigBase } from 'ecosystem'

export const productAttributes: Record<
  'sv' | 'no' | 'da',
  Required<AppConfigBase>['productAttributes']
> = {
  sv: [
    { name: 'Höjd', order: 1 },
    { name: 'Garanti', order: 2 },
    { name: 'Bredd', order: 3 },
    { name: 'Dörrlås', order: 4 },
    { name: 'Djup', order: 5 },
    { name: 'Uv-glas', order: 6 },
    { name: 'Vikt kg', order: 7 },
    { name: 'Antivibrationsteknik', order: 8 },
    { name: 'Ljudnivå', order: 9 },
    { name: 'Kolfilter', order: 10 },
    { name: 'Antal flaskor', order: 11 },
    { name: 'Omgivningstemperatur', order: 12 },
    { name: 'Temperaturzoner', order: 13 },
    { name: 'Förbrukning kWh/år', order: 14 },
    { name: 'Omhägningsbar', order: 15 },
    { name: 'Strömförbrukning (W)', order: 16 },
    { name: 'Belysning', order: 17 },
    { name: 'Ström spänning (V)', order: 18 },
    { name: 'Temperatur', order: 19 },
    { name: 'Sladdlängd', order: 20 },
    { name: 'Antal Hyllor', order: 21 },
    { name: 'Energiförbrukning', order: 22 },
    { name: 'Färg', order: 23 },
    { name: 'Klimatklass', order: 24 }
  ],
  no: [
    { name: 'Høyde', order: 1 },
    { name: 'Garanti', order: 2 },
    { name: 'Bredde', order: 3 },
    { name: 'Dørlås', order: 4 },
    { name: 'Dybde', order: 5 },
    { name: 'UV-glass', order: 6 },
    { name: 'Vekt kg', order: 7 },
    { name: 'Vibrasjonsteknologi', order: 8 },
    { name: 'Lydnivå', order: 9 },
    { name: 'Kullfilter', order: 10 },
    { name: 'Antall flasker', order: 11 },
    { name: 'Omgivelsestemperatur', order: 12 },
    { name: 'Temperatursoner', order: 13 },
    { name: 'Forbruk kWh/år', order: 14 },
    { name: 'Omhengslingbar', order: 15 },
    { name: 'Strømforbruk (W)', order: 16 },
    { name: 'Belysning', order: 17 },
    { name: 'Spenning (V)', order: 18 },
    { name: 'Temperatur', order: 19 },
    { name: 'Ledningslengde', order: 20 },
    { name: 'Antall hyller', order: 21 },
    { name: 'Energiforbruk', order: 22 },
    { name: 'Farge', order: 23 },
    { name: 'Klimaklasse', order: 24 }
  ],
  da: [
    { name: 'Højde', order: 1 },
    { name: 'Garanti', order: 2 },
    { name: 'Bredde', order: 3 },
    { name: 'Dørlås', order: 4 },
    { name: 'Dybde', order: 5 },
    { name: 'UV-glas', order: 6 },
    { name: 'Vægt kg', order: 7 },
    { name: 'Vibrationsteknologi', order: 8 },
    { name: 'Lydniveau', order: 9 },
    { name: 'Kulfilter', order: 10 },
    { name: 'Antal flasker', order: 11 },
    { name: 'Omgivelsestemperatur', order: 12 },
    { name: 'Temperaturzoner', order: 13 },
    { name: 'Forbrug kWh/år', order: 14 },
    { name: 'Omhængsbar', order: 15 },
    { name: 'Strømforbrug (W)', order: 16 },
    { name: 'Belysning', order: 17 },
    { name: 'Spænding (V)', order: 18 },
    { name: 'Temperatur', order: 19 },
    { name: 'Ledningslængde', order: 20 },
    { name: 'Antal hylder', order: 21 },
    { name: 'Energiforbrug', order: 22 },
    { name: 'Farve', order: 23 },
    { name: 'Klimaklasse', order: 24 }
  ]
}
